
import * as React from "react";
import classNames from "classnames";

import styles from "./Medal.scss";

import { DivTooltip, Tooltip, TooltipBody } from "@wg/wows-react-uikit";

import { MEDALS_MAP } from "../../../helpers/cwars";

export type IProps = {
  size?: "small" | "medium" | "large";
  league: number;
  withoutTooltip?: boolean;
};

const Medal = (props: IProps) => {

  return MEDALS_MAP[props.league] && props.withoutTooltip !== null && props.withoutTooltip !== undefined ? <DivTooltip className={classNames(styles.container, styles[`league-${props.league}`], props.size ? styles[props.size] : styles.small)} tooltipBody={<Tooltip>
                        <TooltipBody>
                            {MEDALS_MAP[props.league].name}
                        </TooltipBody>
                    </Tooltip>}>
        </DivTooltip> : <div className={classNames(styles.container, styles[`league-${props.league}`], props.size ? styles[props.size] : styles.small)}>
            </div>;
};

export default Medal;